import React from "react";

const ProgressBar = ({
  percentage,
  gradient = false,
  showPercentage = true,
  height = "h-6",
}) => {
  const getColorByPercentage = (percentage) => {
    if (percentage < 50) return "var(--color-success)";
    if (percentage < 80) return "var(--color-warning)";
    return "var(--color-danger)";
  };

  // Determine the progress bar's background color or gradient
  const progressBarColor = gradient
    ? `linear-gradient(90deg, var(--color-primary-light) 0%, var(--color-primary-dark) 100%)`
    : getColorByPercentage(percentage);

  const neutralLight = `var(--color-neutral-light)`;
  const textColor = `var(--color-text)`;

  return (
    <div
      className={`relative w-full ${height} rounded-full overflow-hidden`}
      style={{ backgroundColor: neutralLight }}
      role="progressbar"
      aria-valuenow={percentage}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full rounded-full transition-all duration-500"
        style={{
          width: `${percentage}%`,
          background: progressBarColor,
        }}
      ></div>

      {showPercentage && (
        <div
          className="absolute inset-0 flex items-center justify-center text-xs font-medium pointer-events-none"
          style={{ color: textColor }}
        >
          {/* {label && `${label} -`} */}
          {percentage}%
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
